/* global axios */
import ApiClient from './ApiClient';

class AiUsageAPI extends ApiClient {
  constructor() {
    super('ai_usage', { accountScoped: true });
  }

  get(month) {
    return axios.get(this.url, { params: { month } });
  }
}

export default new AiUsageAPI();
